import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";
import { alpha } from "@mui/material/styles";

export const useStyles = makeStyles<Theme>((theme) => ({
  block: {
    width: "100%",
  },
  title: {
    marginBottom: 16,
  },
  content: {
    width: "100%",
    '@media (max-width: 767px)': {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      flexDirection: "column",
      gap: 8,
    }
  },
  row: {
    width: "100%",
    padding: "4px 12px",
  },
  new_payout: {
    marginBottom: 16,
  },
  btn: {
    marginBottom: 16,
  },
  title_id: {
    display: "flex",
  }
}));
